<template>
  <div class="person">
    <div class="insured-info">
      <div class="hd">
        <h4 class="title">
          {{ insuredInfo.insuranceName }}
        </h4>
        <span
          v-if="insuredInfo.fmType == 1"
          class="after-bdr"
          :class="{ active: isEffect(insuredInfo) }"
        >{{ isEffect(insuredInfo) ? '已生效' : '已失效' }}</span>
        <!-- <a class="assert-r"
          v-if="insuredInfo.resultUuid"
          :href="`planbkTemplate.html?nw=1&theme=${insuredInfo.theme}&uuid=${insuredInfo.resultUuid}`">详情</a> -->
      </div>
      <div class="info">
        <p>保险公司：{{ insuredInfo.companyName }}</p>
        <p>首年保费：{{ insuredInfo.baof }}元</p>
        <!-- <span class="mr">投保人：{{insuredInfo.name}}</span> -->
        <p v-if="insuredInfo.insuranceDayStr">
          <span>投保日：{{ insuredInfo.insuranceDayStr }}</span>
        </p>
      </div>
    </div>
    <div class="fd">
      <div v-if="!folding || showInsTable" class="instable">
        <!-- v-if="showInsTable" -->
        <div
          v-for="(row, i) in instable"
          v-if="row[0]"
          :key="i"
          class="row after-bd-b"
        >
          <div
            v-for="(cell, index) in row"
            :key="index"
            class="cell after-bd-r"
            :class="{ 'text-justify': index == 0 && cell.length >= 7 }"
          >
            {{ cell }}
          </div>
        </div>
      </div>
      <toggle-desc
        v-if="folding"
        class="fm-toggle-table"
        @toggle="toggle"
      />
    </div>
  </div>
</template>

<script>
import { washKeys } from 'base/config'
import { formatTenThousand } from 'common/js/format'
import ToggleDesc from 'components/toggleDesc/toggleDesc'

const tableHead = ['险种', '保额', '缴费期间', '保费']
const YEAR = 365 * 24 * 60 * 60 * 1000

export default {
  components: {
    ToggleDesc,
  },
  props: {
    tableData: {
      type: Array,
      default: null,
    },
    insuredInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    folding: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showInsTable: false,
      instable: [],
    }
  },
  watch: {
    insuredInfo: {
      handler: 'initTable',
      immediate: true,
    },
  },
  created() {},
  methods: {
    initTable() {
      const { tableData, _normalizeTable } = this
      this.instable = _normalizeTable(tableData)
    },
    toggle() {
      this.showInsTable = !this.showInsTable
    },
    washMain(data) {
      let ret = Object.assign({}, data)
      for (let key in ret) {
        if (washKeys.indexOf(key) > -1) {
          ret[key] = ('' + ret[key]).replace(/\d+.\d+|\d+/, '<span>$&</span>')

          // --fix--
          if (key === 'baoeDesc') {
            ret[key] = ret[key] + '元'
          }
        }
      }
      return ret
    },
    isEffect({ birthday, insuranceDay, duration } = {}) {
      let time
      if (duration === 'a999') {
        time = 9999
      } else if (duration.search('a') !== -1) {
        time =
          duration.replace(/a/g, '') -
          this.getAgeFromBirth(birthday, insuranceDay)
      } else if (duration.search('b') !== -1) {
        time = duration.replace(/b/g, '') * 1
      }
      const dayTime = new Date(insuranceDay)

      return (
        new Date(
          dayTime.getFullYear() + time,
          dayTime.getMonth(),
          dayTime.getDate()
        ) >= new Date()
      )
    },
    getAgeFromBirth(birth, aDate) {
      const nowDate = aDate ? new Date(aDate) : new Date()
      const bDate = new Date(birth)
      var age = nowDate.getFullYear() - bDate.getFullYear()
      if (
        nowDate.getMonth() - bDate.getMonth() < 0 ||
        (nowDate.getMonth() - bDate.getMonth() === 0 &&
          nowDate.getDate() - bDate.getDate() < 0)
      ) {
        age--
      }
      return age
    },
    _normalizeTable(data) {
      let foot = ['合计', '', '', 0]
      let ret = [tableHead]
      let totalBf = 0
      if (!Array.isArray(data)) return [foot]
      data.forEach((item) => {
        let baoeDp = formatTenThousand(item.baoeDesc || item.baoe) || '-'
        if (!item.calMethod) {
          if (item.showPlanDesc) {
            baoeDp = item.planDesc
          } else if (item.showPlanDesc === 'undefined') {
            // planDesc 存在且不等于 plan 显示
            if (item.planDesc && item.planDesc != item.plan) {
              baoeDp = item.planDesc
            }
          }
        }
        ret.push([
          item.name,
          baoeDp,
          `${item.iDurationDesc ? item.iDurationDesc : '-'}/${
            item.pPeriodDesc ? item.pPeriodDesc : '-'
          }`,
          item.baofDesc || item.baof || '-',
        ])
        totalBf += parseFloat(item.baof) || 0
      })
      foot[3] = this.totalBaof || totalBf || '-'
      // ret.push(foot);
      return ret
    },
  },
}
</script>

<style lang="postcss" scoped>
@import 'variable';
.person {
  position: relative;
  width: 100%;
  @apply --box;

  .text-justify {
    text-align: justify;
  }

  .insured-info {
    padding: 20px 15px 0;
    margin-bottom: 15px;
    .hd {
      margin-bottom: 15px;
      > span {
        position: absolute;
        padding: 1px 3px;
        margin-left: 3px;
        font-size: 12px;
        color: #999;
        transform: scale(0.83);
        transform-origin: left bottom;
        &:after {
          border-color: #999;
        }
      }
      .active {
        color: var(--fm-main-color);
        &:after {
          border-color: var(--fm-main-color);
        }
      }
      > a {
        float: right;
        margin-top: 3px;
        padding-right: 12px;
        font-size: 13px;
        color: #ed9e14;
        &:before {
          @apply --extend-click;
        }
        &:after {
          width: 8px;
          height: 8px;
          margin-top: -4px;
          border-color: #ed9e14;
        }
      }
    }
    .info {
      color: #666;
      line-height: 1.2;
      font-size: 14px;
      p {
        margin-bottom: 9px;
      }
      span {
        max-width: 50%;
        display: inline-block;
        vertical-align: middle;
        @apply --text-ellipsis;
      }
      .mr {
        padding-right: 26px;
      }
    }
    .title {
      display: inline-block;
      max-width: 60%;
      padding: 0;
      vertical-align: middle;
      @apply --text-ellipsis;
    }
  }

  .fm-toggle-table {
    padding: 0 0 6px !important;
    box-sizing: content-box;
    outline: 0;
  }
}

.instable {
  margin: 0 2px 9px;
  font-size: 13px;
  text-align: center;
  position: relative;
  &:before {
    @apply --bd-w;
    background-color: var(--efive-color);
    left: 0;
    top: 0;
    transform-origin: 100% 0;
  }
  &:after {
    @apply --bd-h;
    background-color: var(--efive-color);
    left: 0;
    top: 0;
  }
  .row {
    display: flex;
    .cell {
      float: left;
      padding: 10px 8px;
      font-size: 12px;
      /*text-align: left;*/
      word-break: break-all;
      &:first-child {
        text-align: left;
      }
      &:nth-child(odd) {
        width: 28.14%;
      }
      &:first-child {
        width: 32.16%;
      }
      &:nth-child(2) {
        width: 18%;
      }
      &:last-child {
        width: 21.7%;
      }
    }
    &:first-child {
      .cell {
        padding: 10px 0;
        text-align: center;
        background: var(--feight-color);
      }
    }
  }
}

@media screen and (device-width <= 320px) {
  .instable {
    .row {
      .cell {
        padding: 8px;
      }
    }
  }
}
</style>